import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const TruncatedTextWithTooltip = ({ text, maxLength = '200px' }) => {
  const displayedText = text || '-';
  const shouldShowTooltip = text && text.length > 0;

  return (
    <div className="text-truncate" style={{ maxWidth: maxLength }}>
      {shouldShowTooltip ? (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>{text}</Tooltip>}
        >
          <span>{displayedText}</span>
        </OverlayTrigger>
      ) : (
        <span>{displayedText}</span>
      )}
    </div>
  );
};

export default TruncatedTextWithTooltip;